import React from 'react';

const MustItem = props => (
  <div
    className="MustItem"
    style={{
      minWidth: props.minWidth,
      ...props.style
    }}
  >
    必須
  </div>
);

export default MustItem;
